import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useAdsAndAddonsMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemAds */
  const menuItemAds = {
    id: "ads",
    title: t("Modules.Ads.ads"),
    url: baseRouteMakerForSuperAdmin(routes.ADS),
  };
  tempMenuGroup.push(menuItemAds);
  /* menuItemAds */

  /* menuItemAddons */
  const menuItemAddons = {
    id: "addons",
    title: t("AppModuleNames.Provider.addons"),
    url: baseRouteMakerForSuperAdmin(routes.ADDONS),
  };
  tempMenuGroup.push(menuItemAddons);
  /* menuItemAddons */

  /* menuItemOrganizationSponsorship */
  const menuItemOrganizationSponsorship = {
    id: "organization-sponsorship",
    title: t("Modules.Ads.organizationSponsorship"),
    url: baseRouteMakerForSuperAdmin(routes.ORGANIZATION_SPONSORSHIP),
  };
  tempMenuGroup.push(menuItemOrganizationSponsorship);
  /* menuItemOrganizationSponsorship */

  return tempMenuGroup;
};
